import { Input } from "@mui/material";
import React, { useEffect, useState } from "react";

const RenderInputComponent = ({
  data,
  setTextValue,
  formData,
  freeFormTabbleEditMainrecord,
  varValue,
  textValue,
  setDialogKeyMapping
}) => {
  const [defaultValue, setDefaultValue] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    if (data && formData?.form?.sFormAction != "EDIT" && defaultValue) {
        setTextValue((prev) => ({
        ...prev,
        [data?.component?.sName]: defaultValue,
      }));
    }
    if (formData?.form?.sFormAction == "EDIT") {
      setTextValue((prev) => ({
        ...prev,
        [data?.component?.sName]:
          freeFormTabbleEditMainrecord[data?.component?.sName],
      }));
    }
  }, [data, freeFormTabbleEditMainrecord, defaultValue]);

  useEffect(() => {
    if(textValue[data?.component?.sName]?.includes("[")){
        setTextValue((prev) => ({
            ...prev,
            [data?.component?.sName]: defaultValue,
        }));
    }
  }, [textValue])

  useEffect(() => {
    if (
      data?.component?.sDefaultValue?.includes("[") ||
      data?.component?.sDefaultValue?.includes("]")
    ) {
      setDialogKeyMapping((prev) => ({...prev, [data?.component?.sName]: data?.component?.sDefaultValue}))
      setDefaultValue(varValue?.[data?.component?.sName]);
      setValue(varValue?.[data?.component?.sName]);
    } else {
      setDefaultValue(data?.component?.sDefaultValue);
      setValue(data?.component?.sDefaultValue);
    }
  }, [data]);

  return (
    <Input
    {...data?.component?.sProps}
    name={data?.component?.sName}
    value={value}
    onChange={(e) => {
        const newValue = e.target.value;
        setValue(newValue);
        setTextValue((prev) => ({
        ...prev,
        [data?.component?.sName]: newValue,
        }));
    }}
    />
  );
};

export default RenderInputComponent;
